import { createFileRoute } from '@tanstack/react-router';
import { TransferPage } from '../components/pages/TransferPage/TransferPage';
import { z } from 'zod/mini';

const searchSchema = z.object({
  accountId: z.optional(z.string()),
  // repeat transaction
  createdAt: z.optional(z.string()),
  transactionId: z.optional(z.string()),
});

export const Route = createFileRoute('/account/transfer')({
  component: TransferPage,
  validateSearch: searchSchema.parse,
});
